import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "login-container"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
import { onMounted, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { ElForm } from 'element-plus';
import { login } from '@/api/tc-server';
import { useUserStore } from '@/store/user';
import { getDictByType } from '@/api/dict';
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {
    const loginForm = ref({
      username: '',
      password: ''
    });
    const loginFormRef = ref(null);
    const dict = ref({});
    // const tipsList = ref([])
    async function getDict(type) {
      const res = await getDictByType({
        type
      });
      if (res.status === 200) {
        // 为 dict 添加索引签名，解决类型错误
        dict.value[type] = res.data;
      }
    }
    const rules = {
      username: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }, {
        min: 3,
        max: 20,
        message: '长度在 3 到 20 个字符',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }, {
        min: 6,
        max: 20,
        message: '长度在 6 到 20 个字符',
        trigger: 'blur'
      }]
    };
    const submitForm = formName => {
      if (!loginFormRef.value) return;
      loginFormRef.value.validate(valid => {
        if (valid) {
          // ElMessage.success('登录成功')
          const userStore = useUserStore();
          // const router = useRouter();
          login(loginForm.value).then(res => {
            console.log(res);
            if (res.status === 200) {
              userStore.setToken(res.data.token);
              userStore.setUserInfo(res.data.userInfo);
              console.log(userStore.token);
            }
          });
        } else {
          ElMessage.error('请检查输入信息');
          return false;
        }
      });
    };
    const resetForm = formName => {
      if (!loginFormRef.value) return;
      loginFormRef.value.resetFields();
    };
    onMounted(async () => {
      await getDict('kefuQRCode');
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_footer = _resolveComponent("el-footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", null, null, -1)), _createVNode(_component_el_card, {
        class: "box-card"
      }, {
        header: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "card-header"
        }, [_createElementVNode("span", null, "个人数据分析共享")], -1)])),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElForm), {
          model: loginForm.value,
          rules: rules,
          ref_key: "loginFormRef",
          ref: loginFormRef,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "username"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: loginForm.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loginForm.value.username = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "password",
              modelValue: loginForm.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => loginForm.value.password = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = $event => submitForm('loginFormRef'))
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 登录 ")])),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = $event => resetForm('loginFormRef'))
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("重置")])),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])]),
        _: 1
      })]), _createVNode(_component_el_footer, {
        class: "footer"
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("a", {
          href: "https://beian.miit.gov.cn/",
          target: "_blank",
          style: {
            "color": "inherit",
            "text-decoration": "none"
          }
        }, "蜀ICP备2025156980号-1", -1)])),
        _: 1
      })]);
    };
  }
});